export interface PriceOffer {
  accommodationID: number;
  arrival: string;
  checkin: string;
  checkout: string;
  departure: string;
  price: number;
  priceTotal: number;
  suggestionLine: string;
}

export interface TravelBookingPriceCost {
  id: number | null;
  title: string;
  position: number;
  price: number;
  quantity: number | null;
  totalPrice: number | null;
  unit: string;
  mandatory: boolean;
}

export const adviceValues = ['bring', 'included', 'on_request'] as const;
export type AdviceValues = typeof adviceValues;

export interface UsageBasedPrice {
  title: string;
  price: number;
  unit: string;
  advice: AdviceValues[number] | null;
}

export interface FixedPrice extends Omit<UsageBasedPrice, 'advice'> {
  quantity: number;
  totalPrice: number;
}

export interface GuestPriceInfo {
  securityDeposit: number;
  securityDepositRefund: 'instantly' | 'one_week' | 'two_weeks' | null;
  securityDepositPaymentType: 'on_location' | 'upfront';
  priceRent: number;
  totalPrice: number;
  payableCasapilot: FixedPrice[];
  payableHost: FixedPrice[];
  optional: (FixedPrice | UsageBasedPrice)[];
  withheldFromDeposit: UsageBasedPrice[];
}

export interface Prices {
  arrival: string;
  durationOfStay: number | null;
  maxOccupancy: number;
  matchingSuggestion: PriceOffer | null;
  matchingPrice: GuestPriceInfo | null;
  alternativeSuggestions: PriceOffer[];
  hasMatchingPrice: boolean;
}

export interface PricesAccommodationMap {
  [accommodationID: number]: Prices;
}
